import React from 'react';
import { useLocation } from 'react-router-dom';
import { Card } from 'react-bootstrap';

const ViewPDFPage = () => {
  // useLocation hook
  const location = useLocation();
  const { state } = location;

  if (!state || !state.fileData) {
    return <div></div>;
  }

  // State Variables
  const fileUrl = `${state.fileData.url}#toolbar=0`;
  const companyName = state.fileData.company; 

  return (
    <div className="container-fluid m-0" >
      <div className="row">
        <div className="row">
          <Card className="col-12 viewpdf-card" >
            <Card.Header>{companyName}-VAPT PDF REPORT</Card.Header>
            <Card.Body>
              <div className='viewpdf-obj'>
                <object data={fileUrl} type="application/pdf" width="100%" height="1000px" aria-label="pdf-content"></object>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ViewPDFPage;